module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074a8_logo_200x200.5c77d1a2.png";